import React, { useEffect, useState } from "react";

import Img from "@assets/img";
import RaffleSwiper from "@components/RaffleSwiper";
import { RAFFLE_TYPE } from "@const/dashboard";
import { RaffleKey, RaffleTitle } from "@const/profile";
import { SearchBy } from "@network/Raffle/type";
import { RaffleDataBased } from "@type/Raffle";
import { SCREEN } from "@type/index";
import * as S from "./style";

interface RaffleItemProps {
  raffleData?: RaffleDataBased;
  screen?: SCREEN;
  limit?: number;
  searchBy?: SearchBy;
  keyword?: string;
  filter?: string;
  skipFirstItem?: boolean;
}

const RaffleSwiperRender: React.FC<RaffleItemProps> = ({
  screen,
  limit,
  searchBy,
  raffleData,
  keyword,
  filter,
  skipFirstItem = true,
}) => {
  const [raffleDataResult, setRaffleDataResult] = useState<RaffleDataBased>();

  useEffect(() => {
    if (raffleData) {
      setRaffleDataResult(raffleData);
    }
  }, [raffleData]);

  // Check if all raffle types are empty
  const allEmpty = RaffleKey.every((item: string) => {
    const data = raffleDataResult?.raffles[item]?.raffles || [];
    return data.length === 0;
  });

  return (
    <>
      {RaffleKey.map((item: string, key) => {
        const data = raffleDataResult?.raffles[item]?.raffles || [];

        return (
          <RaffleSwiper
            key={key}
            initData={data}
            title={RaffleTitle[item]}
            type={RAFFLE_TYPE[item]}
            screen={screen ?? SCREEN.DASHBOARD}
            limit={limit ?? 5}
            searchBy={searchBy}
            keyword={keyword}
            filter={filter}
            skipFirstItem={skipFirstItem}
          />
        );
      })}
      {allEmpty && (
        <S.NoSelectionBg>
          <img src={Img.NoSelectionBg} alt="No data" width={350} />
          <p>No raffle displayed</p>
        </S.NoSelectionBg>
      )}
    </>
  );
};

export default RaffleSwiperRender;
